(function ( $ ) {
	/*
	 * Relies on SnapSVG : http://snapsvg.io/
	 * Previously was purely JS but we ran into problems with IE
	 */
	$.fn.bordermagic = function () {
		var elem = $( this ),
			parent = elem.parent(),
			$elements = $( '.animate-border' ),
			animationSpeed = 500; // milliseconds

		var init = function () {

				// Relies on SnapSVG
				if ( typeof Snap === 'undefined' ) {
					return false;
				}

				setTimeout( function () {
					setupEverything();
					bindEvents();
				}, 1000 );
			},
			setupEverything = function () {
				setData();
				//console.log( $elements );

				$elements.each( function () {

					var $this = $( this ),
						parentClassToBindTo = $this.data( 'parent-class-to-bind' ),
						$bindTo = $this;

					// If that data property exists, we want to bind the hover to THAT
					if ( parentClassToBindTo ) {
						var $tryParent = $this.parents( '.' + parentClassToBindTo );

						// Let's make sure it actually exists
						if ( $tryParent.length > 0 ) {
							$bindTo = $tryParent;
						}
					}

					injectSvg( $this, $bindTo );

					$bindTo.addClass( 'animated-border-target' );

				} );
			},
			destroyForResize = function () {

				$elements.each( function ( i, el ) {
					$( this ).find( '.border-svg' ).remove();
				} );

			},
			setData = function () {
				$elements.each( function ( i, el ) {
					var $this = $( this ),
						currHeight = $this.outerHeight(),
						currWidth = $this.outerWidth(),
						borderColour = $this.css( 'border-top-color' ),
						borderWidth = parseInt( $this.css( 'border-top-width' ) );

					$this.data( 'border-magic', {
						height      : currHeight,
						width       : currWidth,
						borderColor : borderColour,
						borderWidth : borderWidth
					} );

					//console.log( 'height : ', currHeight, "  width  : ", currWidth, "   color  : ", borderColour );

				} );
			},
			bindEvents = function () {

				$( '.animated-border-target' ).on( 'mouseenter touchstart', function ( e ) {
					var $this = $( this ),
						path = $( this ).data( 'snapPath' ),
						pathLength = path.getTotalLength();

					Snap.animate( pathLength, 0,
						function ( val ) {
							path.attr( { "stroke-dashoffset" : val } );
						},
						animationSpeed
					);


				} )
					.on( 'mouseleave touchend', function ( e ) {
						var path = $( this ).data( 'snapPath' ),
							pathLength = path.getTotalLength(),
							currStrokeDashOffset = parseInt( getComputedStyle( path.node ).strokeDashoffset );

						//console.log("Border: Mouse left", currStrokeDashOffset, pathLength, animationSpeed, path);

						Snap.animate( currStrokeDashOffset, pathLength,
							function ( val ) {
								path.attr( { "stroke-dashoffset" : val } );
							},
							animationSpeed
						);
					} );


				// On resize
				var debouncedResize = debounce( function () {
					destroyForResize();
					setupEverything();
				}, 250 );

				window.addEventListener( 'resize', debouncedResize );

			},
			injectSvg = function ( $element, $bindTo ) {
				var elementData = $element.data( 'border-magic' );

				if ( elementData ) {
					var $svgContainer = $( '<svg class="border-svg" />' ).appendTo( $element ),
						snap = Snap( $svgContainer[ 0 ] ),
						halfBorderWidth = parseInt( elementData.borderWidth ) / 2,

						topRight = (elementData.width - halfBorderWidth ) + ' 0 ',
						bottomRight = (elementData.width - halfBorderWidth ) + ' ' + (elementData.height - ( elementData.borderWidth * 1.5) ) + ' ',
						bottomLeft = halfBorderWidth + ' ' + ( elementData.height - ( elementData.borderWidth * 1.5) ) + ' ',
						topLeft = halfBorderWidth + '  ' + ' 0 ',

						strPath = 'M ' + topRight + // move to top right
							' L ' + bottomRight + // line to bottom right
							' L ' + bottomLeft + // line to bottom left
							' L ' + topLeft,  // line to top left
						surroundingPath = snap.path( strPath ),
						pathLength = surroundingPath.getTotalLength();

					//	console.log( topRight, bottomRight, bottomLeft, topLeft );


				// 	snap.attr( {
				//	viewBox : '0 0 ' + elementData.width + ' ' + ( elementData.height - elementData.borderWidth )
				// 	} )

					surroundingPath.attr( {
						stroke              : elementData.borderColor,
						strokeWidth         : elementData.borderWidth,
						fill                : 'none',
						'stroke-dasharray'  : pathLength + ' ' + pathLength,
						'stroke-dashoffset' : pathLength
					} );


					// The animation and the "hit target" for the hovers might not be the same
					// Since we're binding to the .animated-border-target, let's store this info there
					$bindTo.data( 'snapObject', snap );
					$bindTo.data( 'snapPath', surroundingPath );

				}
			};

		init();
		return this;
	};

}( jQuery ));
